import React from 'react';
import { Container, Typography } from '@mui/material';
import { useTitle } from '../../contexts/TitleContext';

const NotAuthorized = () => {
	const { setTitle } = useTitle();
	setTitle('Not Authorized!');
	return (
		<Container sx={{ marginTop: '43vh' }} maxWidth='sm'>
			<Typography
				sx={{
					fontSize: '2em',
					fontWeight: 300,
					'& strong': { fontWeight: 400 },
				}}
				variant='h1'
				align='center'
			>
				<strong>Error 403</strong>: You are not authorized to visit that page!
			</Typography>
		</Container>
	);
};

export default NotAuthorized;
